export const OPEN_COUNTRY_SELECTOR = "OPEN_COUNTRY_SELECTOR";
export const CLOSE_COUNTRY_SELECTOR = "CLOSE_COUNTRY_SELECTOR";
export const SET_COUNTRY = "SET_COUNTRY";
export const LOAD_COUNTRY = "LOAD_COUNTRY";
export const LOAD_CURRENCY = "LOAD_CURRENCY";
export const SET_CURRENCY = "SET_CURRENCY";
export const VOUCHER_CURRENCY_ERROR =
  "cannotchangetonongbpcurrencyifvoucherisinbag";
